<template>
  <div class="tutorial-right">
    <h1>{{ content.title }}</h1>
    <div class="description-container">
      <p>{{ content.description }}</p>
      <tutorial-button
        :action="action"
        :content="content.cta"
      />
    </div>
    <img
      ref="arrowTutorial"
      class="arrow"
      :src="content.arrow"
      alt="arrow"
    >
  </div>
</template>

<script>
import mixin from './tutorialMixin'

export default {
  name: 'TutorialRight',
  mixins: [mixin]
}
</script>

<style lang="scss">
.tutorial-right {
  z-index: 9004;
  position: fixed;
  top: 45%;
  left: 25%;

  .arrow {
    position: fixed;
    transform: translateY(65%) translateX(57em);
    width: 15%;
  }

  .description-container {
    width: 100%;
  }
}
</style>
